// Mode palettes for Annie Mode app-global theming.
//
// Eric and Annie each get a distinct visual identity. The mobile app reads
// these via the NativeWind `vars()` runtime API: brand-primary / -secondary /
// -accent are defined in tailwind.config.js as `rgb(var(--brand-primary) / <alpha-value>)`,
// and ModeThemeProvider writes the active palette's RGB triplets into those vars.
//
// The hex form is kept for non-NativeWind consumers (StatusBar tint, future
// web parity in PR #149+, native splash assets) — these are intentionally
// derivative of the RGB triplets and must stay in sync (the modePalettes
// test asserts each hex matches its RGB triplet).
//
// RGB triplet format is space-separated `R G B` (no commas) because that's
// what `rgb(var(--brand-primary) / <alpha-value>)` expects.
const eric = {
    name: 'Eric',
    tagline: 'Disciplined edge.',
    brandPrimary: '#4B51E6',
    brandSecondary: '#7B7FF0',
    brandAccent: '#FFD166',
    brandPrimaryRgb: '75 81 230',
    brandSecondaryRgb: '123 127 240',
    brandAccentRgb: '255 209 102',
    brandGradient: ['#4B51E6', '#7B7FF0'],
    wordmark: {
        family: 'Inter',
        style: 'normal',
        weight: 700,
    },
};
const annie = {
    name: 'Annie',
    tagline: 'Sniper-grade signals.',
    brandPrimary: '#B91C1C',
    brandSecondary: '#7F1D1D',
    brandAccent: '#FCA5A5',
    brandPrimaryRgb: '185 28 28',
    brandSecondaryRgb: '127 29 29',
    brandAccentRgb: '252 165 165',
    brandGradient: ['#B91C1C', '#7F1D1D'],
    wordmark: {
        family: 'Georgia',
        style: 'italic',
        weight: 700,
    },
};
export const modePalettes = {
    ERIC: eric,
    ANNIE: annie,
};
export function getModePalette(mode) {
    return modePalettes[mode];
}
